<template>
  <a-table class="table-component" :columns="columns" :data-source="data.result">
    <template #bodyCell="{ index, column, record }">
      <template v-if="column.key === 'index'">
        {{ index + 1 }}
      </template>

      <template v-if="column.key === 'status'">
        <span v-if="record.status === 0"
          ><span class="radius-icon" style="background-color: #c9cdd4"></span>关闭</span
        >
        <span v-else-if="record.status === 1"><span class="radius-icon"></span>开启</span>
      </template>
      <template v-if="column.key === 'action'">
        <a @click="showEdit(record)">编辑</a>
        <a>备份</a>
      </template>
    </template>
  </a-table>
</template>
<script>
import { PLAN_TABLE_COLUMNS } from "@/constant/views/dashboard/devops/backup/index";
import { defineComponent } from "vue";
import { Table } from "ant-design-vue";

export default defineComponent({
  emits: ["show"],
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },

  components: {
    [Table.name]: Table
  },

  setup(props, context) {
    const showEdit = (item) => {
      context.emit("show", item);
    };
    return {
      showEdit,
      columns: PLAN_TABLE_COLUMNS
    };
  }
});
</script>
<style lang="less" scoped>
.radius-icon {
  display: inline-block;
  width: 6px;
  height: 6px;
  margin: 0 10px 2px 0;
  background-color: #0bb837;
  border-radius: 6px;
}
:deep(thead th) {
  font-size: 12px;
}
:deep(tbody td) {
  font-size: 14px;
  a {
    margin-right: 24px;
  }
}
.rule-icon {
  margin-right: 8px;
  vertical-align: middle;
}
</style>
